import { render } from "./NcrmMitpSyncPanel.vue?vue&type=template&id=04f50aba&scoped=true"
import script from "./NcrmMitpSyncPanel.vue?vue&type=script&lang=js"
export * from "./NcrmMitpSyncPanel.vue?vue&type=script&lang=js"

import "./NcrmMitpSyncPanel.vue?vue&type=style&index=0&id=04f50aba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f50aba"]])

export default __exports__